const STORE_USER_DETAILS = "STORE_USER_DETAILS";
const UPDATE_USER_DETAILS = "UPDATE_USER_DETAILS";

export default {
  STORE_USER_DETAILS,
  UPDATE_USER_DETAILS
};
